import { Helmet } from 'react-helmet-async';

export default function SEO({ 
  title = "AfriOne B&D",
  description = "AfriOne B&D",
  ogTitle,
  ogDescription,
  twitterTitle,
  twitterDescription,
  canonical,
  keywords
}) {
  const baseUrl = "https://afrionebd.com";
  const ogImage = `${baseUrl}/og-image.jpg`;
  const twitterImage = `${baseUrl}/twitter-image.jpg`;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content="AfriOne B&D" />
      
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical || baseUrl} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="AfriOne B&D" />
      <meta property="og:locale" content="fr_BE" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical || baseUrl} />
      <meta name="twitter:title" content={twitterTitle || title} />
      <meta name="twitter:description" content={twitterDescription || description} />
      <meta name="twitter:image" content={twitterImage} />
      
      {/* Canonical */}
      <link rel="canonical" href={canonical || baseUrl} />
    </Helmet>
  );
}
